module.exports = require("./pcm.d.ts");